<span
  tabindex="0"
  role="button"
  (click)="togglePopup()"
  (keydown.enter)="togglePopup()"
  class="flex-container flex-align-center menu-item nav"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
>
  <i [nimbusIcon]="ICONS.HEADSET"></i>
  <span [ngClass]="presenceClass$ | async" class="presence-indicator"></span>
  <nimbus-tooltip [text]="TranslationKeys.DutyContactCenterAssistant | translate" [position]="'right'" [theme]="'Dark'"></nimbus-tooltip>
</span>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayPanelClass="duty-profile-overlay"
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayPositions]="cdkConnectedPositions"
  [cdkConnectedOverlayOpen]="isOpen$ | async"
  [cdkConnectedOverlayHasBackdrop]="true"
  (positionChange)="onPositionChange($event)"
  (backdropClick)="onBackdropClick()"
>
  <div
    class="nimbus-tooltip-complex duty-profile-overlay-container"
    [ngClass]="cdkArrowCssClass$ | async"
    cdkTrapFocus
    cdkTrapFocusAutoCapture="true"
    (keydown.escape)="onBackdropClick(); $event.stopPropagation()"
  >
    <div class="duty-profile-overlay-header">
      <nimbus-user-info
        [presenceClass]="(presence$ | async)?.availability | lowercase"
        [presenceTooltip]="presenceTooltip$ | async"
        [responsibilityProfiles]="userResponsibilityProfiles$ | async"
        (responsibilityProfileChanged)="onResponsibilityProfileChanged($event)"
      ></nimbus-user-info>
      <nimbus-after-call-work-state></nimbus-after-call-work-state>
      <nimbus-rona-state></nimbus-rona-state>
      <nimbus-availability-state></nimbus-availability-state>
    </div>
    <div class="duty-profile-overlay-body">
      <img id="duty-img" [src]="dutyImageSrc$ | async" alt="" />
    </div>
  </div>
</ng-template>
